
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { validateUUID, sanitizeUUID } from "./validation";

export const checkManagerAuth = async () => {
  try {
    const memberId = sessionStorage.getItem('organization_member_id');
    
    // Use the validation utility and also check for empty strings
    if (!validateUUID(memberId) || memberId === '') {
      console.log("No valid member ID found in session");
      // Clear invalid session data
      sessionStorage.removeItem('organization_member_id');
      return false;
    }

    const { data, error } = await supabase
      .from('organization_members')
      .select('id, organization_id, role')
      .eq('id', memberId)
      .maybeSingle();

    if (error) {
      console.error('Manager auth check error:', error);
      return false;
    }

    if (!data) {
      console.error('No member found with ID:', memberId);
      sessionStorage.removeItem('organization_member_id');
      return false;
    }

    return true;
  } catch (error) {
    console.error('Manager auth check error:', error);
    // Clear any invalid session data on error
    sessionStorage.removeItem('organization_member_id');
    return false;
  }
};

export const clearManagerAuth = () => {
  sessionStorage.removeItem('organization_member_id');
};

export const setMemberContext = async (memberId: string | null) => {
  if (!memberId) {
    console.error('Cannot set member context: memberId is null');
    return false;
  }

  try {
    // Use the validation utility
    if (!validateUUID(memberId)) {
      console.error('Invalid UUID format for memberId');
      return false;
    }

    // First verify the member exists and get their details
    const { data: member, error: memberError } = await supabase
      .from('organization_members')
      .select('id, organization_id, role')
      .eq('id', memberId)
      .maybeSingle();

    if (memberError) {
      console.error('Error checking member:', memberError);
      toast.error('Failed to verify member access');
      return false;
    }

    if (!member) {
      console.error('Member not found:', memberId);
      toast.error('Member not found');
      return false;
    }

    // Set the member ID in session storage
    sessionStorage.setItem('organization_member_id', memberId);

    return true;
  } catch (error) {
    console.error('Error setting member context:', error);
    toast.error('Failed to set member context');
    return false;
  }
};
